/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Con, TextCon, HeaderText, Subtext, RedDot } from "./styled/exhibition";
import { ButtonComponent } from "../Component/ButtonComponent";
import { ModalComponent } from "../Component/Modal";
import Logo from "../Assets/Images/Logo";
import { useLocation } from "react-router-dom";

// Exhibition assets
const EXHIBITION_IMG =
  "https://storage.googleapis.com/destination_ulearn/july-exhibition.png";
const IPAD_FRAME =
  "https://storage.googleapis.com/uapply/Group%2034140%20(2).png";

// Reusable iPad frame showing the exhibition poster inside it
const IpadPoster = () => (
  <div style={{ position: "relative", width: "100%" }}>
    {/* iPad Frame */}
    <img
      src={IPAD_FRAME}
      alt="iPad Frame"
      style={{
        display: "block",
        width: "100%",
        position: "relative",
        zIndex: 1,
      }}
    />
    {/* Inner Content Container */}
    <div
      style={{
        position: "absolute",
        top: "3%",
        left: "4.5%",
        width: "91%",
        height: "94%",
        borderRadius: 4,
        overflow: "hidden",
        zIndex: 2,
      }}
    >
      {/* Blurred background fill */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url('${EXHIBITION_IMG}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(20px)",
          transform: "scale(1.1)",
        }}
      />
      {/* Main poster (contained, no cropping) */}
      <img
        src={EXHIBITION_IMG}
        alt="Ulearn Exhibition July 2026"
        style={{
          position: "absolute",
          top: 4,
          left: 0,
          width: "102%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  </div>
);

// PC (desktop) hero layout styles
const exhibitionPcStyles = `
  .exhibition-pc {
    position: relative;
    width: 100%;
    overflow: hidden;
    background:
      radial-gradient(1100px 620px at 88% -8%, rgba(41, 156, 247, 0.14), transparent 60%),
      radial-gradient(760px 520px at 6% 110%, rgba(253, 62, 96, 0.08), transparent 60%),
      linear-gradient(180deg, #ffffff 0%, #f3f8ff 100%);
  }
  /* Decorative blurred brand blobs */
  .exhibition-pc::before,
  .exhibition-pc::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    filter: blur(10px);
    pointer-events: none;
    z-index: 0;
  }
  .exhibition-pc::before {
    width: 18px;
    height: 18px;
    background: #fd3e60;
    top: 18%;
    left: 46%;
    filter: none;
    opacity: 0.85;
  }
  .exhibition-pc::after {
    width: 26px;
    height: 26px;
    background: #299cf7;
    bottom: 16%;
    left: 40%;
    filter: none;
    opacity: 0.6;
  }

  .exhibition-pc-inner {
    position: relative;
    z-index: 1;
    direction: rtl;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 64px;
    max-width: 1200px !important;
    margin: 0 auto;
    min-height: 100vh;
    padding: 48px 24px;
  }

  .exhibition-pc-text {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    /* LTR flex context so align-items:flex-end reliably pins items to the
       RIGHT; each text element keeps its own direction:rtl for Arabic. */
    direction: ltr;
    align-items: flex-end;
    text-align: right;
  }


  /* Eyebrow badge above the headline */
  .exhibition-pc-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 26px;
    padding: 7px 16px;
    border-radius: 100px;
    background: rgba(41, 156, 247, 0.10);
    color: #1477d1;
    font-family: Cairo;
    font-weight: 700;
    font-size: 14px;
    direction: rtl;
  }
  .exhibition-pc-eyebrow::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fd3e60;
  }

  /* Degree-level pills */
  .exhibition-pc-pills {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 22px;
    direction: rtl;
  }
  .exhibition-pc-pills .pill {
    padding: 9px 20px;
    border-radius: 100px;
    background: #ffffff;
    border: 1px solid #e6ebf2;
    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.05);
    font-family: Cairo;
    font-weight: 700;
    font-size: 16px;
    color: #1e2432;
  }

  /* Date / venue meta rows */
  .exhibition-pc-meta {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 26px;
    width: 100%;
    align-items: flex-end;
  }
  .exhibition-pc-meta .meta-row {
    display: flex;
    align-items: center;
    gap: 12px;
    direction: rtl;
    font-family: Cairo;
    font-weight: 600;
    font-size: 18px;
    color: #1e2432;
  }
  .exhibition-pc-meta .meta-icon {
    flex: none;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: rgba(41, 156, 247, 0.12);
    color: #1477d1;
    font-size: 19px;
  }

  .exhibition-pc-cta {
    margin-top: 34px;
  }

  /* iPad visual with glow */
  .exhibition-pc-visual {
    position: relative;
    flex: 0 0 46%;
    max-width: 580px;
    display: flex;
    justify-content: center;
  }
  .exhibition-pc-visual::before {
    content: "";
    position: absolute;
    inset: 6% 4% 4% 4%;
    border-radius: 32px;
    background: radial-gradient(closest-side, rgba(41, 156, 247, 0.32), transparent 78%);
    filter: blur(28px);
    transform: translateY(18px) scale(1.05);
    z-index: 0;
  }
  .exhibition-pc-visual .ipad-wrap {
    position: relative;
    z-index: 1;
    width: 100%;
    filter: drop-shadow(0 26px 44px rgba(16, 24, 40, 0.22));
  }

  @media (max-width: 1200px) {
    .exhibition-pc-inner {
      gap: 32px;
    }
    .exhibition-pc-visual {
      flex-basis: 44%;
    }
    .exhibition-pc-pills .pill {
      font-size: 15px;
      padding: 8px 16px;
    }
  }
`;

if (
  typeof document !== "undefined" &&
  !document.querySelector("#exhibition-pc-styles")
) {
  const styleEl = document.createElement("style");
  styleEl.id = "exhibition-pc-styles";
  styleEl.textContent = exhibitionPcStyles;
  document.head.appendChild(styleEl);
}

export const Exibition = () => {
  const [show, setshow] = React.useState(false);

  React.useEffect(() => {
    // document.body.style.overflow = "hidden";
    // document.body.style.height = "100%";
  }, []);

  const arabic = true;

  const location = useLocation();
  console.log("first", location.pathname);
  return (
    <>
      <Con>
        <div
          style={{ zIndex: 99, position: "relative" }}
          className="mobile-view"
        >
          <div
            style={{
              width: "100%",
              zIndex: 99,
              padding: 15,
              position: "absolute",
              margin: "auto",
            }}
          >
            <Logo width={"145px"} height={"36.75px"} />
          </div>
          <img
            style={{
              position: "relative",
              //   bottom: 20,
              width: "80%",
              zIndex: 9,
            }}
            src={
              arabic
                ? "https://cdn.ulearn.study/Subject-removebg.png"
                : "https://cdn.ulearn.study/Subject-removebg.png"
            }
            alt="img"
          />
          <img
            alt="img"
            src="https://storage.googleapis.com/uapply/flag-bg.png"
            style={{
              width: "100%",
              position: "absolute",
              top: 0,
              height: "100%",
              left: 0,
            }}
          />
        </div>

        <div className="mobile-view">
          <TextCon
            direction={arabic ? "flex-end" : "flex-start"}
            className="container "
          >
            <HeaderText arabic={arabic}>
              أكبر معرض للجامعات البريطانية في الكويت 2026
            </HeaderText>
            {/* <HeaderText arabic={arabic}>{t("common:homeHeader2")}</HeaderText> */}

            <div style={{ marginTop: 20 }}>
              <Subtext fontWeight={900} arabic={arabic}>
                لغة <RedDot /> بكلوريوس <RedDot /> ماجستير <RedDot /> دكتوراة
              </Subtext>
            </div>

            <div className="mobile-view" style={{ width: "90%" }}>
              <ButtonComponent
                style={{
                  marginTop: 20,
                  padding: "0 58px",
                  width: "90%",
                  zIndex: 99,
                  marginBottom: 20,
                  borderRadius: 8,
                }}
                width="100%"
                className="res-home-btn "
                label={"تسجيل حضورك"}
                loading={false}
                btnType={"dark"}
                onClick={() => setshow(true)}
              />
            </div>
          </TextCon>
        </div>

        <div className="pc-view exhibition-pc">
          <div className="exhibition-pc-inner container">
            {/* Text column */}
            <div className="exhibition-pc-text">
              <Logo width={"180px"} height={"45px"} />

              <span className="exhibition-pc-eyebrow">
                معرض يوليرن للجامعات البريطانية
              </span>

              <HeaderText
                arabic={arabic}
                style={{ marginTop: 18, lineHeight: "1.25", fontSize: "52px" }}
              >
                أكبر معرض للجامعات
                <br />
                البريطانية في الكويت 2026
              </HeaderText>

              <div className="exhibition-pc-pills">
                <span className="pill">لغة</span>
                <span className="pill">بكلوريوس</span>
                <span className="pill">ماجستير</span>
                <span className="pill">دكتوراة</span>
              </div>

              <div className="exhibition-pc-meta">
                <div className="meta-row">
                  <span className="meta-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="4.5" width="18" height="17" rx="3" />
                      <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
                    </svg>
                  </span>
                  <span>تاريخ 11 يوليو من الساعة 4م إلى 9م</span>
                </div>
                <div className="meta-row">
                  <span className="meta-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </span>
                  <span>سيتي تاور، الدور العاشر (مقر معهد يوليرن)</span>
                </div>
              </div>

              <ButtonComponent
                style={{
                  marginTop: 34,
                  padding: "0 64px",
                  width: "max-content",
                  height: 56,
                  zIndex: 99,
                  borderRadius: 12,
                  fontSize: 18,
                }}
                width="100%"
                className="res-home-btn exhibition-pc-cta"
                label={"تسجيل حضورك"}
                loading={false}
                btnType={"dark"}
                onClick={() => setshow(true)}
              />
            </div>

            {/* iPad visual column */}
            <div className="exhibition-pc-visual">
              <div className="ipad-wrap">
                <IpadPoster />
              </div>
            </div>
          </div>
        </div>
        <div
          className="mobile-view"
          style={{ zIndex: 99, position: "relative" }}
        >
          <Subtext
            fontWeight={900}
            arabic={arabic}
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "0 20px",
            }}
          >
            تاريخ 11 يوليو من الساعة 4م إلى 9م
          </Subtext>

          <Subtext
            fontWeight={900}
            arabic={arabic}
            style={{
              marginBottom: 50,
              display: "flex",
              justifyContent: "center",
              padding: "0 20px",
            }}
          >
            سيتي تاور، الدور العاشر (مقر معهد يوليرن)
          </Subtext>
          <div
            style={{
              position: "relative",
              width: "90%",
              margin: "0 auto",
              bottom: 25,
            }}
          >
            <IpadPoster />
          </div>
          <div>
            <img
              alt="img"
              src="https://storage.googleapis.com/uapply/blue-bg.png"
              style={{
                width: "100%",
                position: "absolute",
                bottom: 0,
                left: 0,
              }}
            />
          </div>
        </div>
        {show ? (
          <ModalComponent show={show} onHide={() => setshow(false)} />
        ) : null}
      </Con>
    </>
  );
};
